import React, { Component } from 'react';
import { connect } from 'react-redux';
import './OurProcess.scss';

class OurProcess extends Component {
  render() {
    return (
      <section id="our-process">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-6">
              <h3>Our Process</h3>
            </div>

            <div className="col-md-4 text-right">
              {/* <a href="#" className="white-square-btn">Learn More <i className="far fa-arrow-right"></i></a> */}
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <div className="process-item">
                <div className="process-icon"><i className="fal fa-chart-pie"></i></div>
                <h4>Research</h4>
              </div>
            </div>

            <div className="col-md-3">
              <div className="process-item">
                <div className="process-icon"><i className="far fa-comment"></i></div>
                <h4>Plan</h4>
              </div>
            </div>

            <div className="col-md-3">
              <div className="process-item">
                <div className="process-icon">
                  <i className="fal fa-pencil-alt"></i>
                </div>
                <h4>Create</h4>
              </div>
            </div>

            <div className="col-md-3">
              <div className="process-item">
                <div className="process-icon"><i className="fal fa-browser"></i></div>
                <h4>Deploy</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default connect()(OurProcess);



// WEBPACK FOOTER //
// ./src/containers/HomePage/parts/OurProcess/OurProcess.js